import { useMediaQuery } from './useMediaQuery';

// issue with webpack. MAKE sure this matches tailwinds.config.js
const screens = {
  'xs': '480px',
  'sm': '640px',
  'md': '768px',
  'lg': '1024px',
  'xl': '1280px',
  '2xl': '1536px',
};
/**
 * Hook that returns Tailwind-style breakpoints as booleans.
 * Matches Tailwind's default screens: sm, md, lg, xl, 2xl.
 */
export function useBreakpoint() {
  const isXs = useMediaQuery(`(max-width: ${screens.xs})`);
  const isSm = useMediaQuery(`(max-width: ${screens.sm})`);
  const isMd = useMediaQuery(`(max-width: ${screens.md})`);
  const isLg = useMediaQuery(`(max-width: ${screens.lg})`);
  const isXl = useMediaQuery(`(max-width: ${screens.xl})`);
  const is2Xl = useMediaQuery(`(min-width: ${screens['xl']})`);

  return {
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,
    is2Xl,
  };
}

/**
 Example Usage:

 import { useBreakpoint } from "@/hooks/useBreakpoint";

export function Navbar() {
  const { isMd, isLg } = useBreakpoint();

  return (
    <nav className="w-full p-4 bg-gray-100">
      {isMd ? <DesktopNav /> : <MobileNav />}
      {isLg && <ExtraWideBanner />}
    </nav>
  );
}
 */
